import {
  Boxes,
  CircleHelp,
  Database,
  Hammer,
  LogOut,
  Settings,
} from "lucide-react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { useWorkspace } from "../workspace/WorkspaceProvider";
import { canAdminister } from "../lib/identity";

export function AppHeader() {
  const { signOut } = useAuth();
  const { bundle } = useWorkspace();
  return (
    <header className="topbar">
      <NavLink to="/" className="brand-lockup">
        <span className="brand-mark">
          <Hammer size={14} />
        </span>
        <div>
          <strong>Catalyst Forge</strong>
          <span>{bundle?.workspace.name || "Workspace"}</span>
        </div>
      </NavLink>
      <nav className="topnav" aria-label="Primary">
        <NavLink to="/" end>
          <Boxes size={14} /> CatalystSuite
        </NavLink>
        {bundle?.member && canAdminister(bundle.member.role) && (
          <NavLink to="/legacy">
            <Database size={14} /> Legacy NPCForge
          </NavLink>
        )}
        <NavLink to="/help">
          <CircleHelp size={14} /> Help
        </NavLink>
        <NavLink to="/settings">
          <Settings size={14} /> Settings
        </NavLink>
      </nav>
      <span className="toolbar-spacer" />
      {bundle?.member && (
        <span className="identity-chip">
          <b>{String(bundle.member.creator_number).padStart(2, "0")}</b>
          {bundle.member.display_name}
          <em>{bundle.member.role}</em>
        </span>
      )}
      <button
        className="icon-button"
        onClick={() => void signOut()}
        aria-label="Log out"
        title="Log out"
      >
        <LogOut size={15} />
      </button>
    </header>
  );
}
